import { AuthService } from './core/services/auth.service';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoaderService } from './core/services/loader.service';
import { LoaderComponent } from './features/loader/loader.component';
import { AlertHandlerComponent } from './shared/ui-components/alert-handler/alert-handler.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoaderComponent,AlertHandlerComponent,],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  authService = inject(AuthService);

  #loaderService = inject(LoaderService);
  isLoading = this.#loaderService.isLoading;
}
